import styled from 'styled-components';
import { ConnectionDegree as ConnectionDegreeXdl } from '@xingternal/badge';
// *** Components ***
const MaximumSizeContainer = styled.div `
  max-height: 318px;
  max-width: 318px;
  position: relative;
`;
const Container = styled.div `
  height: 0;
  padding-top: 100%;
  width: 100%;
`;
const ConnectionDegree = styled(ConnectionDegreeXdl) `
  bottom: -4px;
  right: -2px;
  z-index: 2;
`;
export const Styled = {
    ConnectionDegree,
    Container,
    MaximumSizeContainer,
};
//# sourceMappingURL=profile-image-responsive.styles.js.map